/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".successmsg[_ngcontent-%COMP%]{text-align:center;width:100%;display:block;padding:15px 0;font-size:25px;font-weight:bolder}"];
export { styles as styles };
